import "cfa-react-components/dist/styles.min.css";
import { StylesProvider } from "@material-ui/core";
import { LoginCallback, SecureRoute, Security } from "@okta/okta-react";
import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useHistory,
} from "react-router-dom";
import DeliveryPartners from "./app/components/DeliveryPartners/DeliveryPartners";
import ArmoredCar from "./app/components/ArmoredCar/ArmoredCar";
import Landing from "./app/components/Landing/Landing";
import OktaAuth, { toRelativeUrl } from "@okta/okta-auth-js";
import { oktaAuthConfig } from "./config";
import RiskAnalysis from "./app/components/RiskAnalysis/RiskAnalysis";

const App: React.FC = (): JSX.Element => {
  const oktaConfig = new OktaAuth(oktaAuthConfig);
  const history = useHistory();

  const restoreOriginalUri = async (
    _oktaAuth: unknown,
    originalUri: string
  ) => {
    history
      ? history.replace(
          toRelativeUrl(originalUri || "/", window.location.origin)
        )
      : window.location.replace("/");
  };

  return (
    <StylesProvider injectFirst>
      <Security oktaAuth={oktaConfig} restoreOriginalUri={restoreOriginalUri}>
        <Switch>
          <Route path="/implicit/callback">
            <LoginCallback />
          </Route>
          <SecureRoute path="/" exact component={Landing} />
          <SecureRoute
            path="/delivery-partners"
            exact
            component={DeliveryPartners}
          />
          {/*<SecureRoute path="/armored-car" exact component={ArmoredCar} />*/}
          <SecureRoute path="/risk-analysis" exact component={RiskAnalysis} />
          <SecureRoute path="/armored-car-excel" exact component={Landing} />
          <SecureRoute
            path="/bank-account-management"
            exact
            component={Landing}
          />
        </Switch>
      </Security>
    </StylesProvider>
  );
};

export default function AppWithRouterAccess(): JSX.Element {
  return (
    <Router>
      <App />
    </Router>
  );
}
